// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__lHH_8","disabled":"styles_disabled__CJskm","titleWrapper":"styles_titleWrapper__0Ku9u","number":"styles_number__PAFul"};